import Image from 'assets/backgrounds/approach.jpg';

export const title = 'FondsConsult — Smarte Fondsselektion';
export const description =
  'Bewährte und innovative Ansätze zur Fondsanalyse und -selektion für fundierte Anlageentscheidungen — FondsConsult';
export const imageUrl = `${window.location.origin}${Image}`;
export const content = 'website';
